// Month/bucket helpers shared by the time-based charts.

export const monthKey = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;

// '2024-03' -> Date(2024, 2, 1)
export const parseMonth = (key) => {
  const [year, month] = String(key).split('-').map(Number);
  return new Date(year, month - 1, 1);
};

export const monthLabel = (keyOrDate) => {
  const date = keyOrDate instanceof Date ? keyOrDate : parseMonth(keyOrDate);
  return date.toLocaleDateString(undefined, { month: 'short', year: '2-digit' });
};

// Every month key between two keys, inclusive, so a category axis has no gaps.
export const buildMonthAxis = (firstKey, lastKey) => {
  const months = [];
  const cursor = parseMonth(firstKey);
  const last = parseMonth(lastKey);
  while (cursor <= last) {
    months.push(monthKey(cursor));
    cursor.setMonth(cursor.getMonth() + 1);
  }
  return months;
};

// The next `count` calendar months starting with the current one.
export const nextMonths = (count, from = new Date()) => {
  const cursor = new Date(from.getFullYear(), from.getMonth(), 1);
  const months = [];
  for (let i = 0; i < count; i += 1) {
    months.push({ key: monthKey(cursor), label: monthLabel(cursor) });
    cursor.setMonth(cursor.getMonth() + 1);
  }
  return months;
};

// Bucket granularity for a cumulative chart given the span it must cover.
export const bucketUnitForSpan = (days) => {
  if (days <= 60) return 'day';
  if (days <= 540) return 'week';
  return 'month';
};

// Axis label for a bucket start date ('YYYY-MM-DD') at a given unit.
export const bucketLabel = (isoDate, unit) => {
  const [year, month, day] = String(isoDate).slice(0, 10).split('-').map(Number);
  const date = new Date(year, month - 1, day || 1);
  if (unit === 'month') return monthLabel(date);
  return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
};
